<div class="flex flex-wrap bg-secondary-greys-white px-[60px] pb-8 pt-16">
  <div class="flex gap-8 hover:cursor-pointer" [routerLink]="['/']">
    <div class="text-[32px] font-light leading-[32px] tracking-[var(--letter-spacing-default)] text-brand-700">
      dCarbonizer
    </div>
    <svg-icon src="images/Layer_1.svg"></svg-icon>
  </div>
  <div class="flex grow flex-wrap items-end justify-end gap-x-40">
    <div class="flex grow items-center justify-end gap-8">
      @if (userService.isAdmin$ | async) {
        <a
          [routerLink]="['admin']"
          routerLinkActive
          #rlaAdmin="routerLinkActive"
          [ngClass]="
            rlaAdmin.isActive ? 'text-brand-700' : 'text-brand-900 hover:bg-secondary-greys-30 hover:text-brand-950'
          "
          class="p-4 text-label-md-500"
          >DASHBOARD</a
        >
        <div class="h-[0px] w-16 rotate-90 border border-secondary-greys-300"></div>
      }
      <a
        [routerLink]="['projects']"
        routerLinkActive
        #rlaProjects="routerLinkActive"
        [ngClass]="
          rlaProjects.isActive ? 'text-brand-700' : 'text-brand-900 hover:bg-secondary-greys-30 hover:text-brand-950'
        "
        class="p-4 text-label-md-500"
        >PROJECTS</a
      >
    </div>
    <div class="flex w-[60px] items-center justify-between">
      <img src="images/User Avatar.png" alt="User Avatar" />
      <div #dropdownTrigger>
        <svg-icon class="hover:cursor-pointer" src="images/Expand Arrow_16px.svg"></svg-icon>
      </div>
    </div>
  </div>
</div>

<div
  #dropdownTarget
  class="z-100 hidden w-[260px] border-0.7 border-secondary-greys-50 bg-secondary-greys-white px-12 py-8 shadow-dropdown"
>
  <ul class="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownDefaultButton">
    <li>
      <div class="px-8 py-4 text-body-md-500">{{ userService.user?.email }}</div>
    </li>
    <li class="h-fit w-min">
      <app-button-secondary
        [ghost]="true"
        icon="images/Logout_24px.svg"
        label="Logout"
        (buttonClicked)="onSelect()"
      ></app-button-secondary>
    </li>
  </ul>
</div>
